<template>
  <main id="page-home" class="news-page">

    <!-- Masthead -->
    <header class="masthead">
      <p class="masthead__subtitle">Platformă română de sondaje de opinie</p>
      <p class="masthead__date">{{ dateString }}</p>
    </header>

    <!-- Polls section (always visible) -->
    <section class="polls-section">
      <h2 class="polls-section__title">Sondaje în desfășurare</h2>

      <!-- Category filter -->
      <div class="polls-filter__category">
        <SelectSearchLookupDropdown
          v-model="selectedCategoryIds"
          :multiple="true"
          endpoint="/lookups/categories"
          placeholder="Filtrează după categorie..."
        />
      </div>

      <!-- Search + Sort -->
      <div class="polls-filter__search-sort">
        <input
          v-model="searchInput"
          type="search"
          class="form-field__input polls-filter__search-input"
          placeholder="Caută sondaje..."
          @input="onSearchInput"
        />
        <SortDropdown v-model="sort" :options="sortOptions" />
      </div>

      <PollsList :sort="sort" :category-ids="selectedCategoryIds" :search="debouncedSearch" :page="page" @update:page="onPageChange" />

      <div v-if="currentUser" class="polls-section__footer">
        <button type="button" class="btn-create" @click="$router.push({ name: 'polls.create' })">Creează un sondaj nou</button>
      </div>
    </section>

  </main>
</template>

<script>
import SelectSearchLookupDropdown from "../../components/SelectSearchLookupDropdown.vue";
import SortDropdown from "../../components/SortDropdown.vue";
import PollsList from "./partials/PollsList.vue";
import authMixin from "../../mixins/authMixin.js";

export default {
  name: "HomeIndexView",
  components: {
    SelectSearchLookupDropdown,
    SortDropdown,
    PollsList,
  },
  mixins: [authMixin],

  computed: {
    dateString() {
      return new Date().toLocaleDateString("ro-RO", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },

  async mounted() {
    await this.fetchCurrentUser();
  },

  beforeUnmount() {
    clearTimeout(this.searchDebounceTimer);
  },

  data() {
    const query = this.$route?.query || {};
    return {
      sort: query.sort || "most_voted",
      selectedCategoryIds: query.categories
        ? query.categories.split(",").map(Number).filter(Boolean)
        : [],
      searchInput: query.search || "",
      debouncedSearch: query.search || "",
      page: Number(query.page) || 1,
      searchDebounceTimer: null,
      sortOptions: [
        { value: "most_voted", label: "Cele mai votate" },
        { value: "least_voted", label: "Cele mai puțin votate" },
        { value: "newest", label: "Cele mai noi" },
        { value: "oldest", label: "Cele mai vechi" },
      ],
    };
  },

  watch: {
    sort() {
      this.page = 1;
      this.syncUrl();
    },
    selectedCategoryIds() {
      this.page = 1;
      this.syncUrl();
    },
    debouncedSearch() {
      this.page = 1;
      this.syncUrl();
    },
  },

  methods: {
    onSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.debouncedSearch = this.searchInput;
      }, 400);
    },

    onPageChange(newPage) {
      this.page = newPage;
      this.syncUrl();
    },

    syncUrl() {
      const query = {};
      if (this.sort && this.sort !== "most_voted") query.sort = this.sort;
      if (this.selectedCategoryIds.length) query.categories = this.selectedCategoryIds.join(",");
      if (this.debouncedSearch) query.search = this.debouncedSearch;
      if (this.page > 1) query.page = String(this.page);
      this.$router.replace({ name: "home", query }).catch(() => {});
    },
  },
};
</script>
